import React, { useState } from "react";
import { useI18n } from "../../i18n/i18nService";
import { useAuth } from "../../contexts/AuthContext";
import { getHashedDeviceId } from "../../utils/hash";
import { useLocation, useNavigate } from "react-router-dom";
import { FlagLanguageSelector } from "../../components/LanguageSelector";
import ThemeToggle from "../../components/ThemeToggle";
import { ButtonCustom, FormError, FormSuccess, InputField } from "../../components/common/Form";

const DefinePasswordPage = () => {
  const { t, i18n } = useI18n(['auth']);
  const { resetPassword, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const phone = location.state?.phone || null;
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [form, setForm] = useState({
    password: null,
    confirm_password: null
  })

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccess(false);
    
    
    if(form.password !== form.confirm_password){
      setError(t('auth:errors.register.password_not_match'))
      return 
    }
    try {
      const deviceId = await getHashedDeviceId();
      await resetPassword({ email: phone, password: form.password, deviceId });
      setSuccess(true);
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 5000)

    } catch (error) {
      console.log(error);
      setError(t(`auth:errors.login.${error.status || 500}`));
      setSuccess(false);
      return;
    }

  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-light-background dark:bg-dark-background">
      <div className="max-w-md w-full p-6 relative rounded-lg shadow-idaraf dark:shadow-idaraf-dark bg-white dark:bg-gray-800">
        <div className="flex justify-center items-center mb-4">
          <img
            src="/images/logo.png" // Assurez-vous que le chemin est correct
            alt="IDARAF"
            className="h-28 w-28 object-contain rounded-full border border-light-tertiary/20 dark:border-dark-tertiary/20 p-1 dark:bg-gray-50"
          />
        </div>

        {/* 🧩 Formulaire de connexion */}
        {/* <h1 className="text-2xl font-bold mb-6 text-center">{t("login")}</h1> */}
        <form onSubmit={handleSubmit} className="space-y-4">

          <h2 className="text-2xl font-bold mb-6 text-center text-light-text/80 dark:text-dark-text">{t("auth:define_password")}</h2>

          {error && <FormError message={error} />}
          {success && <FormSuccess message={t('auth:password_reset_success')} />}
          

          <InputField
            name="password"
            label={t("auth:password")}
            type="password"
            placeholder={t("auth:password_placeholder")}
            autoComplete="current-password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />

          <InputField
            name="confirm_password"
            label={t("auth:confirm_password")}
            type="password"
            placeholder={t("auth:password_placeholder")}
            autoComplete="current-password"
            value={form.confirm_password}
            onChange={(e) => setForm({ ...form, confirm_password: e.target.value })}
            required
          />

          <ButtonCustom
            type="submit"
            loading={loading}
            variant="primary"
            className="w-full py-2 px-4 rounded-md text-white font-semibold"
          >
            {t("auth:submit")}
          </ButtonCustom>

          <div className="flex justify-between items-center mt-4">
            <div className="text-sm text-gray-600 dark:text-gray-400  ">
              {t("auth:no_account")}{" "}
            </div>
            <ThemeToggle />
          </div>
        </form>
        <div className="absolute top-5 right-5 flex items-center justify-center">
          <FlagLanguageSelector
            currentLanguage={i18n.language}
            onChange={changeLanguage}
          />
        </div>
      </div>
    </div>
  );
};

export default DefinePasswordPage;
